import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the The Fit Club and by choosing the right plan and program I already achieved my ideal body!",
    name: 'MATHEW HENDRICKSON',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'I was not sure if I would reach my goal but The Fit Club helped me achieve my dream of getting the perfect body...',
    name: 'JOHN KEVIN',
    status: 'PROFFESSIONAL'
  },
  {
    image : image3,
    review:'This is like dream come to true... Thank you The Fit Club for lending a hand to achieve success...',
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
